<template>
    <div class="query-container">
        <v-textarea
                class="query"
                solo
                name="query"
                label="Write your query here…"
                v-model="textQuery">
        </v-textarea>
        <div v-if="isQueryValid === false" class="error-message">
            Query is not valid
        </div>
        <div v-if="isQueryOnly === true" class="error-message">
            This query is can not be presented in visual editor
        </div>
    </div>
</template>

<script>
    export default {
        name: "CommunityManualQuery",
        props: ['value', 'isQueryValid', 'isQueryOnly'],
        data: () => ({
            textQuery: null
        }),
        mounted() {
            this.value ? this.textQuery = this.value : ''
        },
        watch: {
            textQuery: {
                handler: function (val, oldVal) {
                    this.$emit('input', val)
                },
                deep: true
            },
            value: {
                handler: function (val, oldVal) {
                    this.textQuery = val;
                },
                deep: true
            }
        }
    }
</script>

<style lang="sass">
@import '@/assets/sass/_variables.sass'

.query-container
  background-color: $blueish
  min-height: 220px

  .query
    background-color: $blueish
    padding-top: 22px
    min-height: 220px

    .v-input__slot
      border: solid 1px $pale-lilac
      padding: 0 24px 18px
      border-radius: 5px
      box-shadow: none !important

      textarea
        min-height: 180px
        resize: none
        color: $dark-grey-blue
        font-family: Roboto Mono, Menlo, monospace
        font-size: 80%

      label
        color: $gray-light
        line-height: 1.5
        font-style: italic
</style>
